import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Card, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";

const TermsAndConditions = () => {
    
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
      }, []);
  
      return (
    <>
  <div className="mainnav min-vh-100">


  <Helmet>
      {/* Primary Meta Tags */}
      <title>
        Terms & Conditions | Karigar India Namkeen Labour Contractor
      </title>

      <meta
        name="description"
        content="Read the Terms & Conditions of Karigar Namkeen Labor Contractor. By accessing our website, you agree to comply with our usage policies, content rights, and service terms."
      />

      <meta
        name="keywords"
        content="Terms and Conditions Karigar Namkeen, Website Terms India, Namkeen Labour Contractor Terms, Usage Policy, Legal Terms"
      />

      <meta name="author" content="Karigar Namkeen Labor Contractor" />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Terms & Conditions | Karigar Namkeen Labor Contractor"
      />
      <meta
        property="og:description"
        content="Understand the terms governing the use of Karigar Namkeen Labor Contractor’s website and services."
      />
      <meta
        property="og:url"
        content="https://www.karigarindia.in/terms-conditions"
      />
      <meta
        property="og:site_name"
        content="Karigar Namkeen Labor Contractor"
      />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:title"
        content="Terms & Conditions | Karigar Namkeen Labor Contractor"
      />
      <meta
        name="twitter:description"
        content="Please review our terms before using the Karigar Namkeen Labor Contractor website."
      />

      {/* Contact Info */}
      <meta name="contact" content="info@karigarindia.in" />
      <meta name="phone" content="+91-7008000756" />
      <meta name="address" content="Bhilwara, Rajasthan, India" />
    </Helmet>

        <Container className="py-3">
          <Row className="justify-content-center">
            <Col xs={12} md={10}>
              <Card className="shadow-lg">
                <Card.Body>
                  <Card.Title as="h2" className="middletext mb-1" data-aos="zoom-in">Terms & Conditions</Card.Title>
                  <Card.Text>
                    <p>Welcome to <b> Namkeen Labor Contractor!</b></p>
                    <p>By accessing this website, you agree to comply with the following terms and conditions:</p>
                    <ul className='p-3'>
                      <li>You must not use this website for any unlawful purpose.</li>
                      <li>All content on this website is the property of Karagir India Namkeen Manufacturer and may not be copied or reused without permission.</li>
                      <li>Services and offerings mentioned are subject to change without prior notice.</li>
                      <li>We are not liable for any loss or damage arising from the use of this website.</li>
                    </ul>
                    <p>Continued use of our site means you accept these terms.</p>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default TermsAndConditions;
